import React from 'react';
import { environments } from '@/environment';
import { BootService } from '@/services/boot';

export const taxUrl = 'https://www.impots.gouv.fr/portail/node/10841';

export function helpCenterUrl(str: string): string {
  const language = str === 'en-GB' || str === 'en-US' ? str.toLowerCase() : str.split('-')[0].toLowerCase();
  return `https://faq.vestiairecollective.com/hc/${language}`;
}

export function chatUrl(partnerId: string, productId: string): string {
  return `/chat/?id=${partnerId}-${productId}`;
}

export function productImage(path: string, width?: number, height?: number): string {
  return path === ''
    ? ''
    : `${environments[BootService.env].imagesBaseUrl}/images/resized/w=${width || 100},h=${
        height || 100
      },q=75,f=auto,/produit/${path}`;
}

export function onImageError(event: React.SyntheticEvent<HTMLImageElement, Event>) {
  event.currentTarget.onerror = null;
}

export function getItemShippingStatusWarehouseUpdateUrl(productId: string | number): string {
  return environments[BootService.env].itemShippingStatusWarehouseUpdateUrl + '?productId=' + productId;
}

export const replaceNToBr = (text: string | null | undefined, isManualAdding?: boolean): string => {
  if (!text) {
    return '';
  }
  // Manual adding is used for the case when the text is already escaped
  return isManualAdding ? text.replace(/\\n/g, '<br />') : text.replace(/\n/g, '<br />');
};

export const mainPageId = 'ordersSalesMainPage';
export const saleListingId = 'ordersSalesSaleListing';
export const stepsId = 'ordersSalesSteps';
export const currentStepId = 'ordersSalesCurrentStep';

/**
 * Check if the step in the timeline is a return shipment step based on its identifier.
 * A return shipment step is identified by an identifier that starts with 'buyer'.
 * @param stepIdentifier
 * @returns
 */
export function isReturnShipmentStep(stepIdentifier: string): boolean {
  return stepIdentifier.startsWith('buyer');
}
